exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1ORkS0-Tcs_er79zwZRdyn{height:100%;min-height:0;-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto}html[dir] ._3RlB7sGWebwIw8GMu1LO5Y{padding:0;-webkit-box-shadow:0 17px 0 -16px \"[theme:neutralLight, default:#edebe9]\";box-shadow:0 17px 0 -16px \"[theme:neutralLight, default:#edebe9]\"}", ""]);
// Exports
exports.locals = {
	"wrapper": "_1ORkS0-Tcs_er79zwZRdyn",
	"shimmerItemWrapper": "_3RlB7sGWebwIw8GMu1LO5Y"
};